import script from "./AdminLogsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLogsView.vue?vue&type=script&setup=true&lang=js"

import "./AdminLogsView.vue?vue&type=style&index=0&id=38777c8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38777c8d"]])

export default __exports__